﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_settingListList from './tpl/settingListList.html';
import View_SettingListListItem from './settingListListItem';

export default Marionette.CollectionView.extend({
    tagName: 'settingListList',
    className:'row',
    childViewContainer: '#settingListList',
    childView: View_SettingListListItem,
    getTemplate: function () {
        return tpl_settingListList();
    },
    initialize: function () {
        this.app = this.options.app;

        this.listenTo(this.collection, 'change', this.render);
    },
    buildChildView: function(child, ChildViewClass, childViewOptions){
        var options = _.extend({model: child}, childViewOptions);
        options.app = this.app;
        var view = new ChildViewClass(options);
        return view;
    }
});
